import produce, { immerable } from 'immer';

interface IProjectPermissionEntity {
	create: boolean;
	edit: boolean;
}

const entityDefaults: IProjectPermissionEntity = {
	create: false,
	edit: false,
};

export class ProjectPermissionsEntity implements IProjectPermissionEntity {
	private [immerable] = true;

	public create = entityDefaults.create;
	public edit = entityDefaults.edit;

	public static build(
		params: Partial<IProjectPermissionEntity> = {}
	): ProjectPermissionsEntity {
		const entity = new ProjectPermissionsEntity();
		entity.create = params.create ?? entityDefaults.create;
		entity.edit = params.edit ?? entityDefaults.edit;
		return entity;
	}

	private constructor() {}

	public setElementCreatePermissions(
		create: boolean
	): ProjectPermissionsEntity {
		return produce(this, (draft: ProjectPermissionsEntity) => {
			draft.create = create;
		});
	}
}
